var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"loading":_vm.loading,"server-items-length":_vm.totalItems,"options":_vm.bOptions},on:{"update:options":function($event){_vm.bOptions=$event}},scopedSlots:_vm._u([{key:"item.quantity_added",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getQuantity("ADD", item))+" ")]}},{key:"item.quantity_used",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getQuantity("USE", item))+" ")]}},{key:"item.quantity_remaining",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getQuantity("", item))+" ")]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }